export const applyTravailFilters = (annonce, filters) => {
  const {
    secteur = [],
    contrat = [],
    ville = [],
    salaireMin,
    salaireMax,
  } = filters;

  const isSecteurFiltered = secteur.length === 0 || secteur.includes(annonce.secteur);
  const isContratFiltered = contrat.length === 0 || contrat.includes(annonce.contrat);
  const isVilleFiltered = ville.length === 0 || ville.includes(annonce.ville);
  const isSalaireFiltered =
    (!salaireMin || annonce.prix >= parseInt(salaireMin, 10)) &&
    (!salaireMax || annonce.prix <= parseInt(salaireMax, 10));

  return isSecteurFiltered && isContratFiltered && isVilleFiltered && isSalaireFiltered;
};
